export default __webpack_public_path__ + "static/media/Bottom_profile.8a86905b.svg";